import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/parts/offers/create`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/parts/offers/add')({
    // Only redirects: `create` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/parts/offers/create', search: true, replace: true });
    },
});
